import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from 'react';
import { getIdIndexDB } from '../../../../../../../pages/page-builder/grapesjs-service';
import './survey-answers-info.scss';
import { getDetailUserSurveyAnswer } from '../../../../../../../service/course-construct/survey-plan';
import { useAddLesson } from '../../../../../../../stores/stores';
import { MenuUnfoldOutlined, SettingOutlined } from '@ant-design/icons';
import { Col, Collapse, Row } from 'antd';
import { formatDateToIsoStringHHss } from '../../../../../../../utils/converDate';
const { Panel } = Collapse;

type UserDetailType = {
  createdDate?: string;
  email?: string;
  industryName?: string[];
  nameUser?: string;
  surveyName?: string;
  totalQuiz?: string;
  universityName?: string;
}

const SurveyAnswersInfo = () => {
  const { t } = useTranslation();
  const isFirstRender = useRef(true);

  const [userDetail, setUserDetail] = useState<UserDetailType>({});

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      getIdIndexDB('current-survey', (val: any) => {
        getUserDetail(val.record.id);
      });
    }
  }, []);

  const getUserDetail = async (id: any) => {
    await getDetailUserSurveyAnswer(id).then((res: any) => {
      setUserDetail(res.data.data);
    });
  }

  return <section className='setting-question-course'>
    <div className="setting-question-course__header flex">
      <SettingOutlined className="setting-question-course__header__second" />
      <div className="setting-question-course__header__title">{t("Thông tin chung", "Thông tin chung")}</div>
    </div>
    <div className="setting-question-course__content">
      <Collapse defaultActiveKey={[1, 2]}>
        <Panel key={1} header={t("Thông tin học viên", "Thông tin học viên")}>
          <div className="sub-content">
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>{t("Họ và tên", "Họ và tên")}</Col>
              <Col span={12} className='sub-content__item__content'>{userDetail.nameUser}</Col>
            </Row>
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>Email</Col>
              <Col span={12} className='sub-content__item__content'>{userDetail.email}</Col>
            </Row>
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>{t("Trường", "Trường")}</Col>
              <Col span={12} className='sub-content__item__content'>{userDetail.universityName}</Col>
            </Row>
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>{t("Chuyên ngành", "Chuyên ngành")}</Col>
              <Col span={12} className='sub-content__item__content'>{userDetail.industryName?.join(', ')}</Col>
            </Row>
          </div>
        </Panel>
        <Panel key={2} header={t("Thông tin Khảo sát", "Thông tin Khảo sát")}>
          <div className="sub-content">
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>{t("Tên khảo sát", "Tên khảo sát")}</Col>
              <Col span={12} className='sub-content__item__content'>{userDetail.surveyName}</Col>
            </Row>
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>{t("Thời gian thực hiện", "Thời gian thực hiện")}</Col>
              <Col span={12} className='sub-content__item__content'>{formatDateToIsoStringHHss(userDetail.createdDate ? userDetail.createdDate : '')}</Col>
            </Row>
            <Row className='sub-content__item'>
              <Col span={12} className='sub-content__item__title'>{t("Số câu trả lời", "Số câu trả lời")}</Col>
              <Col span={12} className='sub-content__item__content'>{userDetail.totalQuiz}</Col>
            </Row>
          </div>
        </Panel>
      </Collapse>
    </div>
  </section>
}

export default SurveyAnswersInfo;